export default {
  home: {
    title: 'الصفحة الرئيسية',
    aiBannerTxt: {
      title: 'Bring AI Education to Life',
      subtitle: 'AI+ Education Digital Empowerment, Integrating Innovative Concepts',
      description: 'Focus on laser customization products and technical services, helping institutions & enterprises integrate "AI+ Education"'
    },
    description: 'مرحبًا بكم في موقعنا التسويقي المبني على Vue.js',
    banner: {
      slide1: {
        title:
          'مجموعات STEAM | مجموعات الذكاء الاصطناعي | مجموعات القطع بالليزر',
        description:
          'نقدم حلول تعليم STEAM المبتكرة ومجموعة متنوعة من الأطقم للعائلات والمعلمين والموزعين، وهي مصممة خصيصًا للأطفال من 3 إلى 16 سنة.',
      },
      slide2: {
        title: 'أطقم احترافية مصممة خصيصًا لتنمية إبداع الأطفال',
        description:
          'تكامل المناهج والمعدات والبرمجيات لسهولة تنفيذ التعلم القائم على المشاريع',
      },
      slide3: {
        title: 'تعليم تكنولوجي موجه للمستقبل',
        description:
          'التجربة العملية والدمج بين التخصصات لتنمية مهارات حل المشكلات والعمل الجماعي',
      },
    },
    factory: {
      banner: {
        alt: 'لافتة المصنع الذكي',
        title: 'حلول المصنع الذكي',
        description:
          'بناء خطوط الإنتاج ｜ الاستشعار الصناعي ｜ تحكم PLC وجمع البيانات',
        image: 'https://picsum.photos/seed/factory-banner/1000/600',
      },
      resourcesTitle: 'الموارد التعليمية',
      resources: [
        {
          title: 'مواد تعليمية قائمة على المشاريع',
          desc: 'عروض تقديمية للمقررات وكتيبات، وتصميم أنشطة الصف واقتراحات التقييم.',
          image: 'https://picsum.photos/seed/factory-res-1/374/217',
        },
        {
          title: 'أمثلة للسيناريوهات والمواد',
          desc: 'أمثلة وأكواد للتحكم في السيور الناقلة، واكتشاف المحطات، وربط المعدات.',
          image: 'https://picsum.photos/seed/factory-res-2/374/217',
        },
        {
          title: 'مهام التوسعة بعد الدرس',
          desc: 'مهام ممتدة واقتراحات للتطبيقات متعددة التخصصات لتعزيز الاستكشاف والإبداع.',
          image: 'https://picsum.photos/seed/factory-res-3/374/217',
        },
      ],
      intro: {
        title: 'نبذة عن المنتج',
        desc: 'يرتكز حل المصنع الذكي على بناء خطوط الإنتاج والتحكم البرمجي، ويغطي الاستشعار الصناعي، والتعرف على المحطات، والتحكم عبر PLC/المتحكمات الدقيقة، وجمع البيانات، مع التركيز على التدريب العملي والمنهجي.',
        bg: 'https://picsum.photos/seed/factory-bg/1200/736',
      },
      course: {
        title: 'الدورات المصاحبة',
        desc: 'تصميم دورات تعليمية قائمة على المشاريع حول بناء خطوط الإنتاج، والاستشعار الصناعي، وتحكم PLC وجمع البيانات، مع التركيز على التطبيق العملي والتدريب المنهجي.',
        image: 'https://picsum.photos/seed/factory-course/668/597',
      },
      equipments: [
        {
          title: 'وحدة السير الناقل',
          image: 'https://picsum.photos/seed/factory-eq-1/209/209',
        },
        {
          title: 'مستشعر ضوئي كهربائي',
          image: 'https://picsum.photos/seed/factory-eq-2/209/209',
        },
        {
          title: 'وحدة تحكم PLC',
          image: 'https://picsum.photos/seed/factory-eq-3/209/209',
        },
        {
          title: 'وحدة الذراع الروبوتية',
          image: 'https://picsum.photos/seed/factory-eq-4/209/209',
        },
        {
          title: 'وحدة التعرف على الباركود',
          image: 'https://picsum.photos/seed/factory-eq-5/209/209',
        },
        {
          title: 'مستشعر درجة الحرارة والرطوبة',
          image: 'https://picsum.photos/seed/factory-eq-6/209/209',
        },
        {
          title: 'وحدة قيادة المحرك',
          image: 'https://picsum.photos/seed/factory-eq-7/209/209',
        },
        {
          title: 'وحدة فحص المحطات',
          image: 'https://picsum.photos/seed/factory-eq-8/209/209',
        },
        {
          title: 'وحدة التوقف الاضطراري الآمن',
          image: 'https://picsum.photos/seed/factory-eq-9/209/209',
        },
        {
          title: 'بوابة جمع البيانات',
          image: 'https://picsum.photos/seed/factory-eq-10/209/209',
        },
      ],
    },
    solutions: {
      title: 'حلول Zetok لتعليم STEAM',
      learnMore: 'اعرف المزيد >',
      items: [
        {
          image: require('@/assets/home/solution1.webp'),
          title: 'مجموعات Zetok',
          description:
            'من خلال التشغيل العملي والتعلم القائم على المشاريع، يتم تنمية التفكير الإبداعي والقدرات العملية.',
          link: '/solutions/kits',
        },
        {
          image: require('@/assets/home/solution2.webp'),
          title: 'آلات القطع والنقش بالليزر Good Laser',
          description:
            'توفر آلات القطع بالليزر تجربة تعلم عملي جديدة تمامًا لتعليم STEAM',
          link: '/solutions/laser',
        },
      ],
    },
    scenes: {
      title: 'السيناريوهات التعليمية',
      items: [
        {
          image: require('@/assets/home/education1.webp'),
          title: 'حلول تعليم STEM',
        },
        {
          image: require('@/assets/home/education2.webp'),
          title: 'حلول مساحات الميكرز',
        },
      ],
    },
    aiBanner: {
      alt: 'لافتة الذكاء الاصطناعي',
      image: require('@/assets/home/aibanner.png'),
    },
    kitsSection: {
      alt: 'مجموعات Zetok',
      title: 'مجموعات الذكاء الاصطناعي',
      description:
        'تتضمن مجموعات الذكاء الاصطناعي عادة أنشطة تفاعلية غنية ومشاريع تطبيقية، مما يحفز اهتمام الطلاب بالتكنولوجيا وفضولهم العلمي.',
      image: require('@/assets/home/kitsbanner.png'),
    },
    kitsCarousel: {
      alt: 'سلايدر المجموعات',
      title: 'تعزيز التفكير الإبداعي',
      items: [
        { image: require('@/assets/home/kits1.png') },
        { image: require('@/assets/home/kits2.png') },
        { image: require('@/assets/home/kits3.png') },
        { image: require('@/assets/home/kits4.png') },
        { image: require('@/assets/home/kits5.png') },
        { image: require('@/assets/home/kits6.png') },
        { image: require('@/assets/home/kits7.png') },
        { image: require('@/assets/home/kits8.png') },
        { image: require('@/assets/home/kits9.png') },
      ],
    },
    products: {
      title: 'مجموعات Zetok وآلات القطع بالليزر Good Laser',
      tabs: {
        kits: 'المجموعات',
        courses: 'الدورات',
        laser: 'معدات الليزر',
        software: 'البرمجيات',
      },
      items: {
        kits: [
          {
            image: require('@/assets/home/product1.webp'),
            title: 'مجموعة مدخل القطع بالليزر',
            description: '(مع ألواح خشبية استهلاكية)',
          },
          {
            image: require('@/assets/home/product2.webp'),
            title: 'صندوق العلوم المدهش',
            description: '(مع ألواح خشبية + حزمة دوائر كهربائية دقيقة)',
          },
          {
            image: require('@/assets/home/product3.webp'),
            title: 'مجموعة برمجة الذكاء الاصطناعي',
            description: '',
          },
        ],
        courses: [
          {
            image: require('@/assets/home/product4.webp'),
            title: 'نظام الاستكشاف العلمي - للأطفال',
            description: '（6 دورات）',
          },
          {
            image: require('@/assets/home/product5.webp'),
            title: 'نظام صانعي STEAM للشباب',
            description: '（3 دورات）',
          },
          {
            image: require('@/assets/home/product6.webp'),
            title: 'دورات القطع بالليزر',
            description: '（3 دورات）',
          },
          {
            image: require('@/assets/home/product7.webp'),
            title: 'نظام دورات الذكاء الاصطناعي',
            description: '（4 دورات）',
          },
        ],
        laser: [
          {
            image: require('@/assets/home/product8.png'),
            title: 'Light 530 ',
            description: 'ماكينة قطع ونقش ليزر CO2 بقدرة 55 واط مكتبية',
          },
          {
            image: require('@/assets/home/product9.png'),
            title: 'Light 640',
            description: 'ماكينة قطع ونقش ليزر احترافية مكتبية',
          },
          {
            image: require('@/assets/home/product10.png'),
            title: 'Light Blue 530 ',
            description: 'ماكينة قطع ونقش ليزر أزرق مكتبية ذكية',
          },
          {
            image: require('@/assets/home/product11.png'),
            title: 'Mark M20',
            description: 'ماكينة وسم ليزر عالية الدقة',
          },
        ],
        software: [
          {
            image: require('@/assets/home/product12.png'),
            title: 'منصة تعلم Zetok',
            description: '',
          },
          {
            image: require('@/assets/home/product13.png'),
            title: 'منصة Zetok السحابية',
            description: '',
          },
          {
            image: require('@/assets/home/product14.png'),
            title: 'Light Maker',
            description: '',
          },
                    {
            image: require('@/assets/home/product15.png'),
            title: 'mind+',
            description: '',
          },
          {
            image: require('@/assets/home/product16.png'),
            title: 'Arduino',
            description: '',
          },
        ],
      },
    },
  },
  switch_lang: 'English',
  nav: {
    products: 'المنتجات',
    smartFarm: 'المزرعة الذكية',
    smartHome: 'المنزل الذكي',
    smartTraffic: 'المرور الذكي',
    smartFactory: 'المصنع الذكي',
    laserSteam: 'طقم القطع بالليزر STEAM',
    dreamScience: 'طقم علوم الأحلام',
    course: 'الدورات',
    device: 'الأجهزة',
    education: 'الحلول التعليمية',
    stem: 'حلول تعليم STEM',
    maker: 'حلول مساحة المبدعين',
    software: 'البرمجيات',
    service: 'الخدمات والدعم',
    afterSale: 'تنزيلات الدروس',
    about: 'من نحن',
    aboutUs: 'من نحن',
    dealer: 'كن موزعًا لنا',
    cooperation: 'استخدام المنتج والتعاون التعليمي',
    news: 'الأخبار',
    coursesSeries: 'أربع سلاسل للبرامج التعليمية',
    viewMore: 'عرض المزيد',
    store: 'متجر'
  },
  globalContactForm: {
    title: 'اتصل بنا',
    subtitle:
      'إذا كان لديك أي أسئلة أو احتياجات، لا تتردد في التواصل معنا وسنخدمك بكل إخلاص',
    fields: {
      name: 'الاسم',
      email: 'البريد الإلكتروني',
      phone: 'الهاتف',
      company: 'الشركة',
      message: 'الرسالة',
    },
    placeholders: {
      name: 'يرجى إدخال الاسم',
      email: 'يرجى إدخال عنوان البريد الإلكتروني',
      phone: 'يرجى إدخال رقم الهاتف',
      company: 'يرجى إدخال اسم الشركة',
      message: 'يرجى كتابة متطلباتك أو أسئلتك',
    },
    validation: {
      name: 'يرجى إدخال الاسم',
      email: 'يرجى إدخال عنوان البريد الإلكتروني',
      emailFormat: 'تنسيق البريد الإلكتروني غير صحيح',
      phone: 'يرجى إدخال رقم الهاتف',
      message: 'يرجى إدخال الرسالة',
    },
    submit: 'إرسال',
    submitting: 'جارٍ الإرسال…',
    visual: {
      title: 'خدمة احترافية',
      description:
        'نركز على تنمية الإبداع التكنولوجي للأطفال من عمر 3 إلى 16 عامًا، وإنشاء مساحات ابتكار، وتطوير المنتجات والمناهج ذات الصلة.',
    },
    contact: {
      phone: 'هاتف الخدمة',
      email: 'عنوان البريد الإلكتروني',
    },
  },
  thankYou: {
    metaTitle: 'شكراً لك',
    title: 'شكراً لتقديمك!',
    description: 'لقد تلقّينا معلوماتك وسنتواصل معك في أقرب وقت ممكن.',
    seoDescription: 'تم استلام الطلب. سيتواصل فريقنا معك قريباً.',
    backHome: 'العودة إلى الصفحة الرئيسية',
    browseProducts: 'تصفح المنتجات',
    contactSupport: 'الاتصال بالدعم',
    nextStepsTitle: 'ما الذي سيحدث بعد ذلك',
    nextSteps: [
      'سيقوم فريقنا بمراجعة طلبك خلال 1–2 يوم عمل.',
      'قد نتواصل معك لطلب مزيد من التفاصيل إذا لزم الأمر.',
      'يمكنك متابعة التصفح أو التواصل معنا عبر الهاتف أو البريد الإلكتروني.',
    ],
    contactTitle: 'هل تحتاج إلى مساعدة فورية؟',
    contactPhoneLabel: 'هاتف الخدمة:',
    contactEmailLabel: 'البريد الإلكتروني:',
  },
  about: {
    banner: {
      alt: 'لافتة من نحن',
      title:
        'تركز Zetok على التعليم الابتكاري، وتقدم أطقمًا ومناهج عالية الجودة',
      image: require('@/assets/about/banner.png'),
    },
    mission: {
      title: 'مهمتنا',
      desc: 'مهمتنا هي تمكين التعليم من خلال تقنيات الذكاء الاصطناعي المتقدمة، وتحفيز الابتكار، وتنمية قادة ومبدعي المستقبل. نحن نؤمن بأن توفير أدوات وحلول تعليمية عالية الجودة يمكن أن يساعد الطلاب والمعلمين على تحقيق إمكاناتهم.',
      image: require('@/assets/about/mission.png'),
    },
    vision: {
      title: 'رؤيتنا',
      desc: 'تمكين التعليم بالتكنولوجيا، ومساعدة كل طالب على الوصول إلى موارد STEM عالية الجودة، وتحفيز الإمكانات، وتنمية مبدعي وقادة المستقبل.',
      image: require('@/assets/about/vision.png'),
    },
    products: {
      title: 'منتجاتنا',
      tabs: ['الأطقم', 'الدورات', 'أجهزة الليزر'],
      items: [
        {
          title: 'الأطقم',
          desc: 'نوفر مجموعة متنوعة من أطقم STEM، بما في ذلك الذكاء الاصطناعي، والروبوتات، والبرمجة، والتجارب العلمية. تم تصميم هذه الأطقم بعناية وسهلة الاستخدام، ومناسبة لمختلف الأعمار.',
          image: require('@/assets/about/kits.png'),
        },
        {
          title: 'الدورات',
          desc: 'تم تصميم دوراتنا بعناية من قبل خبراء التعليم لتتكامل مع الأطقم وتوفر تجربة تعلم شاملة. تغطي محتويات الدورات من المفاهيم الأساسية إلى التطبيقات المتقدمة، ومناسبة لمختلف المستويات.',
          image: require('@/assets/about/courses.png'),
        },
        {
          title: 'أجهزة الليزر',
          desc: 'آمنة وسهلة الاستخدام / تم تصميم أجهزة القطع والنقش بالليزر الخاصة بنا خصيصًا للبيئات التعليمية، وهي آمنة ودقيقة وسهلة التشغيل. توفر هذه الأجهزة للطلاب فرصة تحويل أفكارهم الإبداعية إلى أعمال ملموسة.',
          image: require('@/assets/about/laser.png'),
        },
      ],
    },
    dealer: {
      banner: {
        alt: 'انضم إلينا وكن موزعًا لـ Zetok',
        title: 'انضم إلينا وكن موزعًا لـ Zetok',
        image: require('@/assets/about/dealer.png'),
      },
      intro: {
        title: 'استكشف فرصًا جديدة في التعليم وشارك ثمار الابتكار!',
        desc: 'تدعوكم Zetok للتوسع في مسار جديد لتعليم STEM، حيث نوفر أطقم الذكاء الاصطناعي وأجهزة الليزر وغيرها لتحفيز إبداع الطلاب. ندعوكم للانضمام إلينا لتحقيق الفوز المشترك في المستقبل!',
        image: require('@/assets/about/dealer1.png'),
      },
      mission: {
        title: 'مهمتنا',
        items: [
          {
            title: 'منتجات رائدة',
            desc: 'الحصول على أدوات تعليم STEAM عالية الجودة في السوق.',
            image: require('@/assets/about/dealer-mission-1.png'),
          },
          {
            title: 'عوائد مجزية',
            desc: 'الاستفادة من خصومات تنافسية وحوافز مبيعات جذابة.',
            image: require('@/assets/about/dealer-mission-2.png'),
          },
          {
            title: 'دعم السوق',
            desc: 'نوفر مواد تسويقية وتدريبًا على المبيعات لمساعدتك على دخول السوق بسرعة.',
            image: require('@/assets/about/dealer-mission-3.png'),
          },
          {
            title: 'شراكة العلامة التجارية',
            desc: 'التعاون مع Zetok لمشاركة قوة العلامة التجارية وموارد السوق.',
            image: require('@/assets/about/dealer-mission-4.png'),
          },
        ],
      },
    },
    cooperation: {
      banner: {
        alt: 'لافتة التعاون',
        title: 'التعاون في المنتجات',
        cta: 'اتصل الآن',
        ctaLink: '/about#contact',
        image: require('@/assets/about/coop-introbanner.png'),
      },
      intro: {
        title: 'تحفيز إمكانات علماء ومهندسي المستقبل',
        desc: 'انضم إلى برنامجنا لنشر تعليم STEM، واحصل على عروض خاصة وتجارب منتجات مصممة خصيصًا للمعلمين. نوفر أدوات STEM مبتكرة للصفوف الدراسية وخصومات حصرية لمساعدتك في تنمية الجيل القادم من المبدعين وحلّالي المشكلات.',
        image: require('@/assets/about/coop-introbanner1.png'),
      },
      stem: {
        title: 'تحرك الآن وابدأ فصلًا جديدًا في تعليم STEM!',
        items: [
          {
            title: 'تجربة منتجات مجانية',
            desc: 'تجربة أدواتنا قبل الشراء.',
            image: require('@/assets/about/edu1.png'),
          },
          {
            title: 'خصومات حصرية',
            desc: 'توفير حلول STEM اقتصادية لفصلك الدراسي أو مدرستك.',
            image: require('@/assets/about/edu2.png'),
          },
          {
            title: 'موارد تعليمية',
            desc: 'توفير موارد تعليمية غنية وخطط دروس لدعم أنشطتك التدريسية.',
            image: require('@/assets/about/edu3.png'),
          },
        ],
      },
      contact: {
        title: 'اتصل بنا',
        desc: 'إذا كان لديك أي أسئلة أو احتياجات، فنرحب بتواصلك معنا وسنخدمك بكل إخلاص',
        image: require('@/assets/about/kites.png'),
      },
    },
    news: {
      banner: {
        alt: 'لافتة مركز الأخبار',
        title: 'مركز الأخبار',
        image: require('@/assets/about/newsbanner.png'),
      },
      title: 'مركز الأخبار',
      tabs: [
        { key: 'company', label: 'أخبار الشركة' },
        { key: 'industry', label: 'أخبار القطاع' },
        { key: 'expo', label: 'أخبار المعارض' },
      ],
      data: {
        company: [
          {
            id: 'company-1',
            title: 'إطلاق طقم الذكاء الاصطناعي الجديد للفصول الدراسية من Zetok',
            date: '2025-04-22',
            image: 'https://picsum.photos/seed/news-company-1-zh/560/342',
          },
          {
            id: 'company-2',
            title: 'التعاون مع مدارس محلية لإطلاق مشاريع STEM تجريبية',
            date: '2025-04-15',
            image: 'https://picsum.photos/seed/news-company-2-zh/560/342',
          },
          {
            id: 'company-3',
            title: 'تحديثات برمجية تعزز تجربة إدارة الصفوف',
            date: '2025-03-30',
            image: 'https://picsum.photos/seed/news-company-3-zh/560/342',
          },
          {
            id: 'company-4',
            title: 'تنظيم ورش عمل تدريبية للمعلمين',
            date: '2025-03-18',
            image: 'https://picsum.photos/seed/news-company-4-zh/560/342',
          },
          {
            id: 'company-5',
            title: 'توسّع شبكة الموزعين لتغطي مناطق أكثر',
            date: '2025-03-02',
            image: 'https://picsum.photos/seed/news-company-5-zh/560/342',
          },
          {
            id: 'company-6',
            title: 'سلسلة دورات جديدة تركز على المشاريع الواقعية',
            date: '2025-02-20',
            image: 'https://picsum.photos/seed/news-company-6-zh/560/342',
          },
          {
            id: 'company-7',
            title: 'مراجعة سنوية تسلط الضوء على نتائج الابتكار',
            date: '2025-02-05',
            image: 'https://picsum.photos/seed/news-company-7-zh/560/342',
          },
          {
            id: 'company-8',
            title: 'برنامج خدمة مجتمعية يجلب STEM إلى فئة الشباب',
            date: '2025-01-25',
            image: 'https://picsum.photos/seed/news-company-8-zh/560/342',
          },
        ],
        industry: [
          {
            id: 'industry-1',
            title: 'اتجاهات عالمية: تطبيق التعلم القائم على المشاريع في STEM',
            date: '2025-04-10',
            image: 'https://picsum.photos/seed/news-industry-1-zh/560/342',
          },
          {
            id: 'industry-2',
            title: 'الذكاء الاصطناعي في التعليم: أفضل الممارسات الناشئة',
            date: '2025-03-25',
            image: 'https://picsum.photos/seed/news-industry-2-zh/560/342',
          },
          {
            id: 'industry-3',
            title: 'المعايير الدراسية الجديدة تركز أكثر على المهارات العملية',
            date: '2025-03-12',
            image: 'https://picsum.photos/seed/news-industry-3-zh/560/342',
          },
          {
            id: 'industry-4',
            title: 'معدات التعليم تقترب أكثر من احتياجات الصفوف الدراسية',
            date: '2025-02-28',
            image: 'https://picsum.photos/seed/news-industry-4-zh/560/342',
          },
          {
            id: 'industry-5',
            title: 'استمرار تقدم مشاريع STEAM في مختلف المناطق التعليمية',
            date: '2025-02-14',
            image: 'https://picsum.photos/seed/news-industry-5-zh/560/342',
          },
          {
            id: 'industry-6',
            title: 'مشاريع التنمية المستدامة تدخل صفوف STEM',
            date: '2025-01-30',
            image: 'https://picsum.photos/seed/news-industry-6-zh/560/342',
          },
          {
            id: 'industry-7',
            title: 'مساحات المبدعين تؤثر في أساليب التعلم الابتكاري',
            date: '2025-01-16',
            image: 'https://picsum.photos/seed/news-industry-7-zh/560/342',
          },
        ],
        expo: [
          {
            id: 'expo-1',
            title: 'ظهور Zetok في معرض تكنولوجيا التعليم',
            date: '2025-04-05',
            image: 'https://picsum.photos/seed/news-expo-1-zh/560/342',
          },
          {
            id: 'expo-2',
            title: 'عرض إنجازات مشاريع الطلاب في المعارض الإقليمية',
            date: '2025-03-22',
            image: 'https://picsum.photos/seed/news-expo-2-zh/560/342',
          },
          {
            id: 'expo-3',
            title: 'عروض تفاعلية في فعاليات الميكرز تجذب الانتباه',
            date: '2025-03-08',
            image: 'https://picsum.photos/seed/news-expo-3-zh/560/342',
          },
          {
            id: 'expo-4',
            title: 'ورش برمجة مرئية موجهة للمعلمين',
            date: '2025-02-21',
            image: 'https://picsum.photos/seed/news-expo-4-zh/560/342',
          },
          {
            id: 'expo-5',
            title: 'عرض المعدات الجديدة لشركاء التعليم',
            date: '2025-02-09',
            image: 'https://picsum.photos/seed/news-expo-5-zh/560/342',
          },
        ],
      },
    },
  },

  finance: {
    contact: {
      success: '提交成功，我们将尽快与您联系',
      error: '提交失败，请稍后重试',
      networkError: '网络错误，请检查网络后重试',
    },
  },
  footer: {
    subscribePlaceholder: 'رقم الهاتف أو عنوان البريد الإلكتروني',
    subscribe: 'اشترك',
    subscribeSuccess: 'تم الاشتراك بنجاح',
    contact: {
      sales: 'خط المبيعات: +86 18379276683',
      service: 'خط الخدمة: +86 400 968 0598',
      email: 'البريد الإلكتروني: sam@zz-steam.com',
      address:
        'العنوان: مبنى هواشنغدا، المبنى A، شارع باقوا الرابع، منطقة فوتيان، شنتشن',
    },
    icp: 'سياسة الخصوصية · اتفاقية المستخدم حقوق النشر © شركة تشونغزه للتعليم (شنتشن) المحدودة رقم التسجيل粤ICP备2024289240号-3',
  },
  solutions: {
    stem: {
      banner: {
        alt: 'لافتة حلول تعليم STEM',
        title: 'الريادة الإبداعية في تعليم STEM',
        description:
          'موجهة لمرحلة K12، نركز على التعليم الإبداعي في STEM، لإثارة حب المعرفة وتنمية التفكير وإشعال شغف البرمجة.',
        image: require('@/assets/solution/banner.png'),
      },
      intro: {
        title: 'تعليم الذكاء الاصطناعي والبرمجة',
        items: [
          {
            icon: require('@/assets/solution/icon1.png'),
            title: 'سهل التعلم والاستخدام',
            description:
              'البرمجة الرسومية، يمكن للمبتدئين البدء فورًا وبناء مشاريع AI بسهولة.',
          },
          {
            icon: require('@/assets/solution/icon2.png'),
            title: 'إمكانات قوية',
            description:
              'أجهزة ذكية وتفاعل صوتي مع إمكانيات إبداعية غير محدودة.',
          },
          {
            icon: require('@/assets/solution/icon3.png'),
            title: 'قابلية توسع عالية',
            description:
              'توصيل المكونات والأجهزة لإطلاق الخيال وتحقيق الإبداع غير المحدود.',
          },
          {
            icon: require('@/assets/solution/icon4.png'),
            title: 'مناهج غنية',
            description:
              'مناهج متكاملة من الأساسيات إلى التطبيق العملي لمساعدة الطلاب على بناء نظامهم المعرفي.',
          },
        ],
      },
      scenes: {
        title: 'تعرّف على دوراتنا المميزة',
        items: [
          {
            tab: 'التعليم المدرسي',
            title: 'التعليم المدرسي بالذكاء الاصطناعي',
            desc: 'استخدام مجموعات الذكاء الاصطناعي لصنع مساعد صوتي ذكي، وتحفيز الاهتمام وتنمية التفكير المنطقي والبرمجة من خلال الممارسة.',
            image: require('@/assets/solution/tc1.png'),
          },
          {
            tab: 'تدريب المسابقات',
            title: 'تدريب المسابقات',
            desc: 'مجموعات ذكية تدعم مسابقات الروبوتات والابتكار التقني، حيث يصمم الطلاب أعمالًا ذكية ويطورون مهارات التعاون والابتكار.',
            image: require('@/assets/solution/tc2.png'),
          },
          {
            tab: 'التعلم المنزلي',
            title: 'التعلم المنزلي',
            desc: 'تعلم مشترك بين الوالدين والأطفال لمشاريع الذكاء الاصطناعي لتنمية المهارات العملية وتعزيز العلاقة ورفع الثقافة التقنية.',
            image: require('@/assets/solution/tc3.png'),
          },
        ],
      },
      split: {
        title: 'الذكاء الاصطناعي + التعليم: بداية عصر جديد من التعلم الذكي',
        desc: 'استخدام تقنيات الذكاء الاصطناعي لتخصيص مسارات التعلم وتحقيق تعليم دقيق، ليتمكن كل طالب من الإبحار بسلاسة في بحر المعرفة.',
        image: require('@/assets/solution/banner1.png'),
      },
      kits: {
        title: 'سلسلة مجموعات STEM',
        images: [
          require('@/assets/solution/kits1.png'),
          require('@/assets/solution/kits2.png'),
          require('@/assets/solution/kits3.png'),
          require('@/assets/solution/kits4.png'),
        ],
      },
    },
    makerSpace: {
      banner: {
        alt: 'لافتة حلول مساحة الميكر',
        title: 'استكشف مساحة الميكر لدينا',
        description:
          'في مساحة الميكر، يندمج التعليم مع التقنيات المبتكرة لتوفير منصة عملية للاستكشاف والتجربة',
        image: require('@/assets/solution/spacebanner.png'),
      },
      intro: {
        title: 'مهارات الميكر الشاملة',
        items: [
          {
            icon: require('@/assets/solution/icon5.png'),
            title: 'تطبيق الأدوات التقنية',
            desc: 'برمجة رسومية سهلة تتيح للمبتدئين بناء مشاريع ذكاء اصطناعي بسرعة',
          },
          {
            icon: require('@/assets/solution/icon6.png'),
            title: 'الانفتاح والمرونة',
            desc: 'مساحة ميكر حرة للاستكشاف وإطلاق الإبداع.',
          },
          {
            icon: require('@/assets/solution/icon7.png'),
            title: 'التطبيق العملي',
            desc: 'ممارسة عملية تشمل التصنيع والتجربة والاستكشاف لبدء رحلة التعلم.',
          },
          {
            icon: require('@/assets/solution/icon8.png'),
            title: 'التعلم التعاوني',
            desc: 'تشجيع الطلاب على العمل الجماعي وتنمية مهارات التعاون والتواصل.',
          },
        ],
      },
      scenes: {
        title: 'سيناريوهات تطبيق مساحة الميكر',
        items: [
          {
            tab: 'الدروس اليدوية المدرسية',
            title: 'الدروس اليدوية المدرسية',
            desc: 'مكمل قوي لدروس الأشغال اليدوية والتصميم الفني وغيرها.',
            image: require('@/assets/solution/tc4.png'),
          },
          {
            tab: 'نوادي البحث والابتكار',
            title: 'نوادي البحث والابتكار',
            desc: 'توفير منصة عملية لنوادي الابتكار المدرسية',
            image: require('@/assets/solution/tc5.png'),
          },
          {
            tab: 'المختبرات التعليمية',
            title: 'المختبرات التعليمية',
            desc: 'مناسبة للمدارس والجامعات أو المختبرات، مع تحديث بيئة التعلم وتوفير آلات نقش ليزر احترافية للطلاب.',
            image: require('@/assets/solution/tc6.png'),
          },
        ],
      },
      split: {
        title: 'أدوات لتحقيق الإبداع',
        desc: 'باستخدام قدرات القطع الدقيقة لآلات الليزر والتفاعل الذكي لروبوتات البرمجة، يمكن للطلاب تحويل الأفكار المجردة إلى أعمال مادية ملموسة',
        image: require('@/assets/solution/banner2.png'),
      },
      kits: {
        title: 'سلسلة مجموعات الميكر',
        images: [
          require('@/assets/solution/kits5.png'),
          require('@/assets/solution/kits6.png'),
          require('@/assets/solution/kits7.png'),
          require('@/assets/solution/kits8.png'),
        ],
      },
    },
  },
  software: {
    banner: {
      alt: 'لافتة صفحة البرامج',
      title: 'مركز برامج Zetok',
      image: require('@/assets/software/banner.png'),
    },
    download: {
      title: 'تحميل البرامج',
      items: [
        {
          key: 'lightmaker-app',
          icon: 'https://picsum.photos/seed/sw-app-1/88/88',
          name: 'تطبيق Light maker',
          buttonText: 'تحميل للهواتف المحمولة',
          link: '#',
        },
        {
          key: 'goodlaser-lightmaker',
          icon: 'https://picsum.photos/seed/sw-app-2/88/88',
          name: 'Good-laser Light maker',
          buttonText: 'تحميل للكمبيوتر',
          link: '#',
        },
        {
          key: 'zz-learning-app',
          icon: 'https://picsum.photos/seed/sw-app-3/88/88',
          name: 'تطبيق منصة التعلم التعليمية Zhongze',
          buttonText: 'تحميل للهواتف المحمولة',
          link: '#',
        },
        {
          key: 'zz-learning-platform',
          icon: 'https://picsum.photos/seed/sw-app-4/88/88',
          name: 'منصة التعلم التكنولوجية Zhongze',
          buttonText: 'تحميل للكمبيوتر',
          link: '#',
        },
      ],
    },
    intro: {
      'goodlaser-lightmaker': {
        header: {
          title: 'برنامج Light Maker المخصص لمعدات الليزر',
          desc: 'يجمع بين التصميم الرسومي والتحكم في الأجهزة لتوفير وقت المستخدم، ويقدم حلاً متكاملاً للتصميم والتحكم في الليزر.',
        },
        items: [
          {
            image: 'https://picsum.photos/seed/zh-intro-1/514/403',
            title: 'نظام تصميم قوي وسهل الاستخدام',
            desc: 'برنامج تصميم قوي يدعم صيغ JPG وDXF وAI وDST وPNG وBMP وTIF وSVG للتصاميم عالية الجودة.',
          },
          {
            image: 'https://picsum.photos/seed/zh-intro-2/514/403',
            title: 'احترافية عالية',
            desc: 'وظائف رسم احترافية تلبي جميع احتياجات التصنيع، سواء التصاميم المعقدة أو عمليات القطع البسيطة.',
          },
          {
            image: 'https://picsum.photos/seed/zh-intro-3/514/403',
            title: 'سهولة التشغيل',
            desc: 'واجهة سهلة الاستخدام مع دعم لمختلف أجهزة الليزر، تجمع بين السهولة والكفاءة في القطع والنقش.',
          },
        ],
      },
      'lightmaker-app': {
        header: {
          title: 'منصة Zetok السحابية',
          desc: 'أداة مبتكرة لإدارة التعليم توفر حلولاً شاملة للمعلمين والطلاب والمدارس، بما في ذلك إدارة الواجبات ومراقبة الأجهزة والصيانة وضبط الإعدادات.',
        },
        items: [
          {
            image: 'https://picsum.photos/seed/zh-intro-app-1/514/403',
            title: 'سهولة التشغيل',
            desc: 'تصنيع بنقرة واحدة مع مكتبة صور وإعدادات مدمجة، مع مراقبة فورية لحالة الأجهزة لضمان سير العملية التعليمية بسلاسة.',
          },
          {
            image: 'https://picsum.photos/seed/zh-intro-app-2/514/403',
            title: 'إدارة موحدة',
            desc: 'دعم ربط أجهزة مختبر الميكر وإدارتها بنقرة واحدة لرفع كفاءة الإدارة.',
          },
          {
            image: 'https://picsum.photos/seed/zh-intro-app-3/514/403',
            title: 'مراقبة في الوقت الحقيقي',
            desc: 'عرض حالة الأجهزة بشكل فوري والإبلاغ عن الأعطال بسرعة مع تذكير دوري بالصيانة لإطالة العمر الافتراضي وتحسين جودة القطع.',
          },
        ],
      },
      'zz-learning-app': {
        header: {
          title: 'تطبيق منصة التعلم التعليمية Zhongze',
          desc: 'منصة متنقلة لتقديم الدورات والتمارين والتقييمات، كنص placeholder قابل للاستبدال لاحقًا.',
        },
        items: [
          {
            image: 'https://picsum.photos/seed/zh-intro-learn-app-1/514/403',
            title: 'ذكي وسهل للمبتدئين',
            desc: 'مكتبة صور وإعدادات جاهزة مع دليل استخدام مفصل على الهاتف، مع دعم سحابي لمراقبة الأجهزة التعليمية في الوقت الحقيقي.',
          },
          {
            image: 'https://picsum.photos/seed/zh-intro-learn-app-2/514/403',
            title: 'إبداع بالذكاء الاصطناعي',
            desc: 'تتيح ميزة إنشاء المواد بالذكاء الاصطناعي تبسيط عملية التصميم ورفع كفاءة الإنتاج عبر أوامر بسيطة أو صور مرجعية.',
          },
          {
            image: 'https://picsum.photos/seed/zh-intro-learn-app-3/514/403',
            title: 'تجربة تعلم عالية الكفاءة',
            desc: 'تجمع منصة Zetok بين التعلم والتصميم والقص بالليزر في نظام واحد بواجهة بطاقات واضحة تزيد من كفاءة التعلم.',
          },
        ],
      },
      'zz-learning-platform': {
        header: {
          title: 'منصة التعلم التكنولوجية Zhongze',
          desc: 'منصة شاملة لإدارة الدورات وتوزيع الواجبات وتحليل التقييمات، حاليًا كنص placeholder قابل للاستبدال لاحقًا.',
        },
        items: [
          {
            image: 'https://picsum.photos/seed/zh-intro-learn-web-1/514/403',
            title: 'إدارة ونشر الدورات',
            desc: 'إدارة مركزية للمحتوى والموارد التعليمية مع دعم لعدة صيغ ومواد.',
          },
          {
            image: 'https://picsum.photos/seed/zh-intro-learn-web-2/514/403',
            title: 'تحليل بيانات الصف',
            desc: 'عرض مرئي لبيانات التعلم ونتائج التقييم لدعم اتخاذ القرارات التعليمية.',
          },
          {
            image: 'https://picsum.photos/seed/zh-intro-learn-web-3/514/403',
            title: 'تعاون متعدد المنصات',
            desc: 'تكامل مع التطبيقات والأجهزة لربط الصف بالتطبيق العملي.',
          },
        ],
      },
    },
  },

  product: {
    farm: {
      banner: {
        alt: 'لافتة المزرعة الذكية',
        title: 'مجموعة المزرعة الذكية التعليمية',
        btnText: 'اذهب للشراء',
        description:
          'تعلم قائم على المشاريع | برمجة + أجهزة + ذكاء اصطناعي | للمرحلتين الابتدائية والمتوسطة',
        image: require('@/assets/product/farm/banner.png'),
      },
      sections: {
        courseTitle: 'محتوى الدورات القائمة على المشاريع',
        resourceTitle: 'الموارد التعليمية',
        equipmentsTitle: 'تجهيزات المعدات',
      },
      courses: [
        {
          bg: '#FBBC05',
          txt: '#fff',
          title: 'محتوى دورات غني ومتنوع',
          desc: '12 درسًا تدريجيًا: من استشعار درجة الحرارة إلى الري الذكي والتحكم في الحرارة، مسار تعلم متكامل ومتقدم.',
          image: require('@/assets/product/farm/education1.png'),
        },
        {
          bg: '#4285F4',
          txt: '#fff',
          title: 'التكامل المعرفي متعدد التخصصات',
          desc: 'يتضمن كل مشروع البرمجة، والأجهزة الإلكترونية، والهياكل الميكانيكية وغيرها من المعارف متعددة التخصصات، مما يساعد الطلاب على دمج ما تعلموه عمليًا وتعزيز مهارات التفكير الشمولي.',
          image: require('@/assets/product/farm/education2.png'),
        },
        {
          bg: '#EA4335',
          txt: '#fff',
          title: 'موضوع قريب من الحياة اليومية',
          desc: 'باتخاذ المزرعة الذكية موضوعًا رئيسيًا، يكون قريبًا من حياة الطلاب اليومية، مما يسهل تحفيز اهتمامهم ومشاركتهم.',
          image: require('@/assets/product/farm/education3.png'),
        },
      ],
      resources: [
        {
          title: 'عروض PPT ومواد تعليمية متكاملة',
          desc: 'عروض ومواد تعليمية لـ 16 درسًا تتوافق بشكل وثيق مع مشاريع التدريس، وتوفر مواد تعليمية غنية للمعلمين وتقلل من عبء التحضير.',
          image: require('@/assets/product/farm/edu1.png'),
        },
        {
          title: 'فيديوهات تركيب للدورات القائمة على المشاريع',
          desc: 'تعرض المواد المرئية عملية بناء المشروع بشكل بصري، مما يساعد الطلاب على فهم خطوات التنفيذ وإتقانها وتحسين كفاءة التعلم.',
          image: require('@/assets/product/farm/edu2.png'),
        },
        {
          title: 'مواد تعليمية مساندة',
          desc: 'توفر المواد التكميلية مثل الكتيبات إرشادات تعلم أكثر تفصيلاً للطلاب، مما يجعل المراجعة بعد الحصة والتعلم الذاتي أكثر سهولة.',
          image: require('@/assets/product/farm/edu3.png'),
        },
      ],
      equipments: [
        {
          title: 'شريط إضاءة RGB',
          image: require('@/assets/product/kits/kits1.png'),
        },
        {
          title: 'وحدة الساعة DS1307',
          image: require('@/assets/product/kits/kits2.png'),
        },
        {
          title: 'مستشعر الحرارة والرطوبة DHT11',
          image: require('@/assets/product/kits/kits3.png'),
        },
        {
          title: 'مستشعر حركة الإنسان',
          image: require('@/assets/product/kits/kits4.png'),
        },
        {
          title: 'وحدة الإضاءة LED',
          image: require('@/assets/product/kits/kits5.png'),
        },
        {
          title: 'وحدة المروحة',
          image: require('@/assets/product/kits/kits10.png'),
        },
        {
          title: 'مفتاح كهروضوئي من نوع الشق',
          image: require('@/assets/product/kits/kits9.png'),
        },
        {
          title: 'وحدة الزر',
          image: require('@/assets/product/kits/kits8.png'),
        },
        {
          title: 'لوحة التحكم',
          image: require('@/assets/product/kits/kits7.png'),
        },
        {
          title: 'لوحة التوسعة',
          image: require('@/assets/product/kits/kits6.png'),
        },
      ],
    },

    home: {
      banner: {
        alt: 'مجموعة المنزل الذكي التعليمية',
        title: 'مجموعة المنزل الذكي التعليمية',
        btnText: 'اذهب للشراء',
        description:
          'تنوير البرمجة والذكاء الاصطناعي | تعلم قائم على المشاريع | الخيار المفضل لمناهج التكنولوجيا في المرحلتين الابتدائية والمتوسطة',
        image: require('@/assets/product/home/banner.png'),
      },
      resourcesTitle: 'مزايا مجموعة المنزل الذكي المبتدئة',
      resources: [
        {
          title: 'موارد غنية',
          desc: 'توفر موارد تعليمية متكاملة للمعلمين والطلاب.',
          image: require('@/assets/product/home/adv1.png'),
        },
        {
          title: 'التكامل متعدد التخصصات',
          desc: 'يتضمن كل مشروع البرمجة، والأجهزة الإلكترونية، والهياكل الميكانيكية وغيرها من المعارف متعددة التخصصات، مما يساعد الطلاب على دمج ما تعلموه عمليًا وتعزيز مهارات التفكير الشمولي.',
          image: require('@/assets/product/home/adv2.png'),
        },
        {
          title: 'مهام إثرائية بعد الحصص',
          desc: 'مهام ممتدة واقتراحات تطبيق متعددة التخصصات لتعزيز الاستكشاف والإبداع.',
          image: require('@/assets/product/home/adv3.png'),
        },
      ],
      course: {
        title: 'الدورات الداعمة',
        desc: 'تتضمن 12 دورة مشاريع عالية الجودة تغطي جوانب متعددة من المنازل الذكية، مثل أجراس الأبواب الإلكترونية، والإضاءة القابلة للتعتيم، والمرآب الذكي، وأنظمة التحكم بكلمة المرور، وإنذارات الغاز، وأنظمة الحماية من السرقة، والإضاءة الملونة، ومصابيح الأجواء الموسيقية، واستشعار ضوء النهار، واستشعار درجة حرارة الغرفة، والمراوح المتحكم بدرجة حرارتها.',
        image: require('@/assets/product/home/banner2.png'),
      },
      scenesTitle: 'سيناريوهات تطبيق متعددة',
      scenes: [
        {
          title: 'التدريس الصفي',
          image: require('@/assets/product/home/c1.png'),
        },
        {
          title: 'التطوير الإبداعي المستقل',
          image: require('@/assets/product/home/c2.png'),
        },
        {
          title: 'تفاعل الأسرة بين الآباء والأبناء',
          image: require('@/assets/product/home/c3.png'),
        },
        {
          title: 'عرض الفعاليات',
          image: require('@/assets/product/home/c4.png'),
        },
      ],
      equipmentsTitle: 'تجهيزات المعدات',
      equipments: [
        {
          title: 'شريط إضاءة RGB',
          image: require('@/assets/product/kits/kits1.png'),
        },
        {
          title: 'وحدة الساعة DS1307',
          image: require('@/assets/product/kits/kits2.png'),
        },
        {
          title: 'مستشعر الحرارة والرطوبة DHT11',
          image: require('@/assets/product/kits/kits3.png'),
        },
        {
          title: 'مستشعر حركة الإنسان',
          image: require('@/assets/product/kits/kits4.png'),
        },
        {
          title: 'وحدة الإضاءة LED',
          image: require('@/assets/product/kits/kits5.png'),
        },
        {
          title: 'وحدة المروحة',
          image: require('@/assets/product/kits/kits10.png'),
        },
        {
          title: 'مفتاح كهروضوئي من نوع الشق',
          image: require('@/assets/product/kits/kits9.png'),
        },
        {
          title: 'وحدة الزر',
          image: require('@/assets/product/kits/kits8.png'),
        },
        {
          title: 'لوحة التحكم',
          image: require('@/assets/product/kits/kits7.png'),
        },
        {
          title: 'لوحة التوسعة',
          image: require('@/assets/product/kits/kits6.png'),
        },
      ],
    },

    factory: {
      banner: {
        alt: 'لافتة المصنع الذكي',
        title: 'مجموعة المصنع الذكي التعليمية',
        btnText: 'اذهب للشراء',
        description: ` · تغطية كاملة للاستشعار / التحكم / القيادة <br>
 · محاكاة خط إنتاج حقيقي<br>
 · إعداد “مهندسي المستقبل”`,
        image: require('@/assets/product/factory/banner.png'),
      },
      resourcesTitle: 'مزايا المنتج',
      resources: [
        {
          title: 'تجربة أساسية للصناعة 4.0',
          desc: 'يتدرب الطلاب على الاستشعار والتحكم والقيادة وإدارة البيانات ضمن خط إنتاج محاكى.',
          image: require('@/assets/product/factory/tc1.png'),
        },
        {
          title: 'تعلم قائم على المشاريع',
          desc: 'يتضمن دروس برمجة و12 دورة مع مواد PPT لتسهيل التعلم.',
          image: require('@/assets/product/factory/tc2.png'),
        },
        {
          title: 'محاكاة سيناريوهات واقعية',
          desc: 'أذرع روبوتية ذكية، وأنظمة فرز تلقائي، ومستودعات ذكية تحاكي إدارة اللوجستيات والمخزون، لتنطلق رحلة ممارسة STEM.',
          image: require('@/assets/product/factory/tc3.png'),
        },
      ],
      intro: {
        title: 'مقدمة المنتج',
        desc: 'مجموعة المصنع الذكي التعليمية هي مجموعة تدريس قائمة على المشاريع تدمج البرمجة، والأجهزة الإلكترونية، والهياكل الميكانيكية، والقطع بالليزر، والتعليم التثقيفي بالذكاء الاصطناعي. وهي مناسبة لطلاب المرحلتين الابتدائية والمتوسطة. وبموضوع “التصنيع الذكي · صناعة المستقبل”، تنمّي قدرات الطلاب في الاستقصاء العلمي، والتصميم الهندسي، والتحكم البرمجي، والابتكار التعاوني من خلال بيئات إنتاج محاكاة.',
        bg: require('@/assets/product/factory/product.png'),
      },
      course: {
        title: 'الدورات الداعمة',
        desc: '12 دورة متميزة تغطي أساسيات المصنع الذكي، وإدراك عمليات الإنتاج، وتطبيقات المستشعرات، وأساسيات القيادة الميكانيكية، وبناء أنظمة النقل، والفرز التلقائي، والتحكم التعاوني لمحطات العمل، وأذرع التجميع، والفرز الذكي، والتحكم وجمع البيانات. تركز الدورات القائمة على المشاريع على الممارسة العملية والتدريب المنهجي.',
        image: require('@/assets/product/factory/course.png'),
      },
      equipmentsTitle: 'تجهيزات المعدات',
      equipments: [
        {
          title: 'شريط إضاءة RGB',
          image: require('@/assets/product/kits/kits1.png'),
        },
        {
          title: 'وحدة الساعة DS1307',
          image: require('@/assets/product/kits/kits2.png'),
        },
        {
          title: 'مستشعر الحرارة والرطوبة DHT11',
          image: require('@/assets/product/kits/kits3.png'),
        },
        {
          title: 'مستشعر حركة الإنسان',
          image: require('@/assets/product/kits/kits4.png'),
        },
        {
          title: 'وحدة الإضاءة LED',
          image: require('@/assets/product/kits/kits5.png'),
        },
        {
          title: 'وحدة المروحة',
          image: require('@/assets/product/kits/kits10.png'),
        },
        {
          title: 'مفتاح كهروضوئي من نوع الشق',
          image: require('@/assets/product/kits/kits9.png'),
        },
        {
          title: 'وحدة الزر',
          image: require('@/assets/product/kits/kits8.png'),
        },
        {
          title: 'لوحة التحكم',
          image: require('@/assets/product/kits/kits7.png'),
        },
        {
          title: 'لوحة التوسعة',
          image: require('@/assets/product/kits/kits6.png'),
        },
      ],
    },

    kits: {
      laserSteam: {
        banner: {
          alt: 'لافتة مجموعة القطع بالليزر STEAM',
          title: 'مجموعة STEAM للقطع بالليزر',
          btnText: 'اذهب للشراء',
          description:
            'حل تعليمي متكامل للتصنيع الذكي لتنمية الابتكار وروح العمل الجماعي',
          image: require('@/assets/product/laser-steam/banner.png'),
        },
        aiBanner: {
          title: 'تعليم الذكاء الاصطناعي، انطلاقة ذكية',
          desc: 'دمج تعليم STEAM بعناصر الذكاء الاصطناعي لصناعة تجربة تعلم متكاملة.',
        },
        resourcesTitle: 'مزايا مجموعة STEAM للقطع بالليزر',
        resources: [
          {
            title: 'نظرية الذكاءات المتعددة',
            desc: 'تعتمد الدورات على نظرية الذكاءات المتعددة لتنمية الإبداع، والتفكير النقدي، وحل المشكلات، والتواصل، والتعاون.',
            image: require('@/assets/product/laser-steam/adv1.png'),
          },
          {
            title: 'التعلم القائم على المشروع',
            desc: 'من خلال التعلم القائم على المشاريع، يتعلم الطلاب بالممارسة مما يعزز كفاءة التعلم والاهتمام.',
            image: require('@/assets/product/laser-steam/adv2.png'),
          },
          {
            title: 'تعليم STEAM',
            desc: 'يدمج المنهج بين العلوم والتكنولوجيا والهندسة والفنون والرياضيات لبناء التفكير متعدد التخصصات لدى الطلاب.',
            image: require('@/assets/product/laser-steam/adv3.png'),
          },
        ],
        teach: {
          title: 'دعم تعليمي تفصيلي',
          tabs: [
            { key: 'cutter', label: 'آلة القطع بالليزر' },
            { key: 'lesson', label: 'الدورات الداعمة' },
            { key: 'material', label: 'المواد التعليمية' },
            { key: 'software', label: 'البرمجيات' },
          ],
          images: {
            cutter: require('@/assets/product/laser-steam/cutter.png'),
            lesson: require('@/assets/product/laser-steam/lesson.png'),
            material: require('@/assets/product/laser-steam/material.png'),
            software: require('@/assets/product/laser-steam/software.png'),
          },
        },
        equipmentsTitle: 'تجهيزات المعدات',
      },
      // Dream Science Kit
      dreamScience: {
        banner: {
          alt: 'لافتة مجموعة علوم الأحلام',
          title: 'صندوق العلوم المدهش (مجموعة علوم الأحلام)',
          description:
            'المفاهيم العلمية | التفكير العلمي | الممارسة الاستقصائية | الموقف والمسؤولية',
          image: require('@/assets/product/dream-science/banner.png'),
        },
        resourcesTitle: 'محتويات المجموعة',
        resources: [
          {
            title: 'مواد التجارب العلمية',
            desc: 'تُستخدم لإكمال مجموعة متنوعة من التجارب والمشاريع العلمية.',
            image: require('@/assets/product/dream-science/kits1.png'),
          },
          {
            title: 'الموارد التعليمية',
            desc: 'تتضمن عروض PPT وملفات تعليمية تدعم فصلاً دراسياً كاملاً من الأنشطة التعليمية، ومتوافقة مع المشاريع ونقاط المعرفة.',
            image: require('@/assets/product/dream-science/kits2.png'),
          },
          {
            title: 'فيديوهات التركيب والملفات التعليمية',
            desc: 'مواد تعليمية إضافية تساعد الطلاب على فهم خطوات التشغيل وإتقانها بشكل أفضل.',
            image: require('@/assets/product/dream-science/kits3.png'),
          },
        ],
        objectivesTitle: 'الأهداف التعليمية',
        objectives: [
          {
            title: 'القدرة على الاستقصاء العلمي',
            desc: 'طرح الأسئلة، ووضع الخطط، وجمع البيانات وتحليلها',
            image: require('@/assets/product/dream-science/education1.png'),
          },
          {
            title: 'القدرة على الممارسة الهندسية',
            desc: 'البناء العملي والاختبار، والتحسين المستمر للحلول',
            image: require('@/assets/product/dream-science/education2.png'),
          },
          {
            title: 'التكامل متعدد التخصصات',
            desc: 'دمج الرياضيات والفيزياء والفنون لإكمال المشاريع',
            image: require('@/assets/product/dream-science/education3.png'),
          },
        ],
        intro: {
          title: 'الفئات المستهدفة',
          description:
            'طلاب المرحلتين الابتدائية والمتوسطة: مناسبة لمختلف الأعمار، وتساعد على تحسين الثقافة العلمية والقدرة العملية. المعلمون: توفر موارد تعليمية وإرشادات لمساعدتهم على تنفيذ الأنشطة التعليمية بشكل أفضل.',
          image: require('@/assets/product/dream-science/banner1.png'),
          alt: 'صورة قسم المقدمة',
        },
      },
    },

    // 查看所有套件页面
    kitsViewAll: {
      banner: {
        alt: 'لافتة عرض جميع المجموعات',
        title: 'سلسلة المجموعات',
        image: require('@/assets/product/kitsall/banner.png'),
      },
      contentTitle:
        'بالتركيز على المشاريع، يطور الطلاب القدرة على استخدام المعرفة بشكل متكامل لحل المشكلات من خلال تنفيذ مهام مشروع متنوعة.',
      moreText: 'اعرف المزيد',
      items: [
        {
          image: require('@/assets/product/kitsall/kits1.png'),
          title: 'مجموعة المزرعة الذكية التعليمية',
          desc: 'تعتمد على المشاريع لتنمية الإبداع والقدرات العملية لدى الطلاب، وتنمية مهارات حل المشكلات الواقعية.',
          link: '/products/laser-steam',
        },
        {
          image: require('@/assets/product/kitsall/kits2-1.png'),
          title: 'مجموعة المنزل الذكي التعليمية',
          desc: 'تدمج البرمجة، والمكونات الإلكترونية، والهياكل الميكانيكية، والقطع بالليزر، ونشر مفاهيم الذكاء الاصطناعي لتوفير تجربة تعلم شاملة.',
          link: '/products/dream-science',
        },
        {
          image: require('@/assets/product/kitsall/kits2-2.png'),
          title: 'مجموعة المرور الذكي التعليمية',
          desc: 'مجموعة تعليمية قائمة على المشاريع تدمج البرمجة، والمكونات الإلكترونية، والهياكل الميكانيكية، والقطع بالليزر، ونشر مفاهيم الذكاء الاصطناعي.',
          link: '/products',
        },
        {
          image: require('@/assets/product/kitsall/kits2-3.png'),
          title: 'مجموعة المصنع الذكي التعليمية',
          desc: 'تغطي أساسيات الذكاء الاصطناعي وحالات تطبيق واقعية، وتوجه الطلاب خطوة بخطوة لبناء إطار معرفي متكامل.',
          link: '/products/traffic',
        },
        // {
        //   image: require('@/assets/product/kitsall/kits2.png'),
        //   title: 'مجموعة STEAM للقطع بالليزر',
        //   desc: 'يتم توجيه مجموعة STEAM للقطع بالليزر وفق نظرية الذكاءات المتعددة وفلسفة تعليم STEAM ونظرية التعلم القائم على المشروع.',
        //   link: '/products/home',
        // },
        // {
        //   image: require('@/assets/product/kitsall/kits2.png'),
        //   title: 'مجموعة علوم الأحلام',
        //   desc: 'تلبي مجموعة علوم الأحلام احتياجات مختلف مراحل التعلم وتحفّز اهتمام الطلاب بالعلوم وروح الاستكشاف.',
        //   link: '/products/farm',
        // },
      ],
    },
    traffic: {
      banner: {
        alt: 'لافتة المرور الذكي',
        title: 'مجموعة المرور الذكي التعليمية',
        btnText: 'اذهب للشراء',
        description: `12 دورة قائمة على المشاريع 
  <br>· برمجة مزدوجة: رسومية / بايثون  <br>
 · محاكاة سيناريوهات واقعية<br>
 · جاهزة للتدريس فور الإخراج من الصندوق`,
        image: require('@/assets/product/traffic/banner.png'),
      },
      resourcesTitle: 'ميزات المنتج',
      resources: [
        {
          title: 'الاستقصاء العلمي والابتكار',
          desc: 'يقوم الطلاب ببناء أنظمة المرور الذكي باستخدام الوحدات الإلكترونية والهياكل الميكانيكية.',
          image: require('@/assets/product/traffic/traffic1.png'),
        },
        {
          title: 'قيمة تعليمية عالية',
          desc: 'تدعم مشاريع مثل أعمدة الإنارة الذكية، وإشارات المرور، ومعابر المشاة، وأنظمة مواقف السيارات لمساعدة الطلاب على فهم مفاهيم المرور الذكي.',
          image: require('@/assets/product/traffic/traffic2.png'),
        },
        {
          title: 'موارد غنية',
          desc: 'موارد تعليمية داعمة متكاملة، بما في ذلك عروض 12 حصة دراسية، وفيديوهات تركيب المشاريع، ومواد إضافية.',
          image: require('@/assets/product/traffic/traffic3.png'),
        },
      ],
      intro: {
        title: 'مقدمة المنتج',
        desc: 'تركز مجموعة المرور الذكي للمرحلتين الابتدائية والمتوسطة على موضوعي “التنقل الذكي” و“السلامة المرورية”، وتدمج تقنيات التحكم الإلكتروني وأجهزة الاستشعار لتوجيه الطلاب لتصميم وبناء أنظمة مرور ذكية يدويًا، ومحاكاة سيناريوهات مرورية واقعية، وتنمية الثقافة العلمية والقدرة على الابتكار.',
        bg: require('@/assets/product/traffic/banner1.png'),
      },
      course: {
        title: 'الدورات الداعمة',
        desc: 'تشمل دورات قائمة على المشاريع في أساسيات استشعار المرور والتحكم، وربط الإشارات، وتخطيط المسارات وغيرها، وقابلة للتكيف مع المراحل والجداول الدراسية المختلفة.',
        image: require('@/assets/product/traffic/course.png'),
      },
      equipmentsTitle: 'تجهيزات المعدات',
      equipments: [
        {
          title: 'شريط إضاءة RGB',
          image: require('@/assets/product/kits/kits1.png'),
        },
        {
          title: 'وحدة الساعة DS1307',
          image: require('@/assets/product/kits/kits2.png'),
        },
        {
          title: 'مستشعر الحرارة والرطوبة DHT11',
          image: require('@/assets/product/kits/kits3.png'),
        },
        {
          title: 'مستشعر حركة الإنسان',
          image: require('@/assets/product/kits/kits4.png'),
        },
        {
          title: 'وحدة الإضاءة LED',
          image: require('@/assets/product/kits/kits5.png'),
        },
        {
          title: 'وحدة المروحة',
          image: require('@/assets/product/kits/kits10.png'),
        },
        {
          title: 'مفتاح كهروضوئي من نوع الشق',
          image: require('@/assets/product/kits/kits9.png'),
        },
        {
          title: 'وحدة الزر',
          image: require('@/assets/product/kits/kits8.png'),
        },
        {
          title: 'لوحة التحكم',
          image: require('@/assets/product/kits/kits7.png'),
        },
        {
          title: 'لوحة التوسعة',
          image: require('@/assets/product/kits/kits6.png'),
        },
      ],
    },
    banner: {
      alt: 'لافتة الصفحة الرئيسية للمنتجات',
      title: 'منتجات وحلول Zetok',
      description:
        'مجموعات ودورات ومعدات وبرمجيات متكاملة لدعم التعلم القائم على المشاريع',
      image: 'https://picsum.photos/id/1069/1600/900',
    },
    courses: {
      banner: {
        alt: 'لافتة وحدة الدورات',
        title: 'أربعة أنظمة منهجية رئيسية',
        description:
          'يغطي المنهج عدة تخصصات مثل العلوم والتكنولوجيا والهندسة والفنون والرياضيات (STEAM)، ويعزز التكامل والتطبيق متعدد التخصصات.',
        image: require('@/assets/product/courses/banner.png'),
      },
      design: {
        title: 'استكشف دوراتنا المميزة',
        nav: ['الأعمار 3–6', 'الأعمار 6–12', 'الأعمار 8–13', 'الأعمار 9–15'],
        entries: [
          {
            title: 'نظام الاستكشاف العلمي · مرحلة ما قبل المدرسة (6 دورات)',
            desc: 'من خلال الظواهر الحياتية الشائعة والوسائل التعليمية العلمية، يستكشف الأطفال ويفهمون القوانين والمبادئ بشكل أعمق.',
            image: require('@/assets/product/courses/courses1.png'),
          },
          {
            title: 'نظام صُنّاع STEAM لليافعين (3 دورات)',
            desc: 'إطلاق الإبداع، واستخدام المعدات، والممارسة العملية، وتحويل الأفكار إلى أعمال حقيقية.',
            image: require('@/assets/product/courses/courses2.png'),
          },
          {
            title: 'نظام منهج القطع بالليزر (3 دورات)',
            desc: 'استخدام المعدات لقطع المكونات الهيكلية المختلفة، وتجميع هياكل ثلاثية الأبعاد وتجميلها. مهارات البرمجة: فهم المنطق ومبادئ البرمجة.',
            image: require('@/assets/product/courses/courses3.png'),
          },
          {
            title: 'نظام منهج الذكاء الاصطناعي (4 دورات)',
            desc: 'استخدام المعدات والأدوات لتصميم المظهر الخارجي للأعمال وجعلها ذكية عبر البرمجة لحل مشكلات الحياة الواقعية.',
            image: require('@/assets/product/courses/courses4.png'),
          },
        ],
        detailsTitle: 'مزايا الدورات',
        details: [
          {
            title: 'تطبيق عملي قوي',
            description: 'الممارسة العملية تحول النظرية إلى مهارات',
            image: require('@/assets/product/courses/icon1.png'),
          },
          {
            title: 'تنمية التفكير الابتكاري',
            description: 'تصميم عملي، وحل إبداعي للمشكلات',
            image: require('@/assets/product/courses/icon2.png'),
          },
          {
            title: 'التعلم القائم على المشاريع',
            description: 'التعلم من خلال المشاريع وإتقان المعرفة بالممارسة',
            image: require('@/assets/product/courses/icon3.png'),
          },
          {
            title: 'استكشاف التقنيات المتقدمة',
            description: 'مواكبة أحدث التقنيات وتعلم تطبيقات المجموعات الذكية',
            image: require('@/assets/product/courses/icon4.png'),
          },
          {
            title: 'تعليم منهجي',
            description: 'من الأساسيات إلى التطبيق العملي خطوة بخطوة',
            image: require('@/assets/product/courses/icon5.png'),
          },
          {
            title: 'مزيج من المتعة والتحدي',
            description:
              'المتعة تشعل الاهتمام، والتحديات تطلق الإمكانات، والنمو عبر الاستكشاف.',
            image: require('@/assets/product/courses/icon6.png'),
          },
        ],
      },
      ai: {
        title: 'سلسلة دورات الذكاء الاصطناعي',
        items: [
          {
            name: 'المزرعة الذكية',
            image: require('@/assets/product/courses/courses5.png'),
          },
          {
            name: 'المنزل الذكي',
            image: require('@/assets/product/courses/courses6.png'),
          },
          {
            name: 'المرور الذكي',
            image: require('@/assets/product/courses/courses7.png'),
          },
          {
            name: 'المصنع الذكي',
            image: require('@/assets/product/courses/courses8.png'),
          },
        ],
      },
      aiBanner: {
        alt: 'لافتة دورات الذكاء الاصطناعي',
        text: 'تعلم قائم على المشاريع وتكامل متعدد التخصصات لتنمية المهارات العملية والتعاونية وقدرات حل المشكلات. مع تحقيق التوازن بين الأمان والتخصيص، يعزز عرض الإنجازات شعور الطلاب بالإنجاز ويدعم نموهم.',
        image: require('@/assets/product/courses/banner1.png'),
      },
    },

    laser: {
      banner: {
        alt: 'منتجات الليزر',
        title: 'منتجات Good Laser',
        description:
          'معدات وحلول القطع والنقش بالليزر الآمنة وسهلة الاستخدام والمخصصة للبيئات التعليمية',
        image: require('@/assets/product/laser/banner.png'),
      },
      advantagesTitle: 'مميزاتنا',
      extraNote: {
        light640_640:
          'أعمال قطع ونقش متميزة\nتتوفر عدة موديلات مع تكوينات طاقة ليزر مختلفة لتلبية الاحتياجات المتنوعة\nنوع الليزر: CO2 تيار مستمر  قدرة الليزر: 60W–130W',
      },
      center: {
        title: 'مركز المنتجات',
        laser_accessories: 'إكسسوارات الليزر',
        air_purifier_name: 'منقي الهواء',
        description:
          'نوفر حلول أجهزة الليزر وفقًا لاختلاف مستوى التعليم في المدارس. أطلقت Zetok أربع حزم رسمية من أجهزة الليزر، ويمكن للمدارس اختيار الأنسب حسب احتياجاتها الفعلية.',
        tabs: [
          {
            key: 'light530',
            label: 'Light 530',
            images: [
              require('@/assets/product/laser/light530.png'),
              require('@/assets/product/laser/light530.png'),
              require('@/assets/product/laser/light530.png'),
              require('@/assets/product/laser/light530.png'),
              require('@/assets/product/laser/light530.png'),
            ],
            advantages: [
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title: 'ليزر عالي الجودة والدقة',
                bgColor: '#4285F4',
                description:
                  'أنبوب ليزر CO₂ عالي الجودة ومسمك بطول موجي 10640nm، يوفر ليزر CO₂ بقدرة 55W عالية الجودة. أقصى سماكة قطع تصل إلى 20 مم (أكريليك)، وسرعة عمل حتى 600 مم/ثانية، ودقة إعادة تموضع 0.025 مم، مما يتيح قطعًا ونقشًا سريعًا ودقيقًا للأعمال الإبداعية.',
                image: require('@/assets/product/laser/light530-1.png'),
              },
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title: 'نظام فلترة ثلاثي مدمج للعادم',
                bgColor: '#FFBC0C',
                description:
                  'تصميم مدمج يجمع بين الفلاتر والكربون النشط وطبقة UV للأوزون. نظام فلترة متعدد المراحل للدخان والغبار أكثر نظافة وصديق للبيئة، ويوفر مساحة دون الحاجة لشراء صندوق فلترة مستقل.',
                image: require('@/assets/product/laser/light530-2.png'),
              },
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title: 'أعلى معايير السلامة',
                bgColor: '#34A853',
                description:
                  'حاصل على أعلى اختبارات السلامة من مختبر SGS ومعتمد من إدارة FDA كمنتج ليزر من الفئة الأولى. تصميم فريد لمؤشرات الأمان وحالة التشغيل يتيح مراقبة الحالة التشغيلية بوضوح.',
                image: require('@/assets/product/laser/light530-3.png'),
              },
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title: 'نظام قطع ليزر سهل الاستخدام وقوي الوظائف',
                bgColor: '#0F9D58',
                description:
                  '· إعداد معلمات مختلفة لمواد المعالجة مثل القطع، والنقش العميق، والنقش السطحي، والمسح.\n· مكتبة واسعة من الرسومات الجاهزة لرفع كفاءة التصميم.\n· الكاميرا تدعم الالتقاط الموضعي لمساعدة التصميم وتحويل الإبداع إلى واقع.',
                image: require('@/assets/product/laser/light530-4.png'),
              },
            ],
          },
          {
            key: 'light640',
            label: 'Light 640',
            images: [
              require('@/assets/product/laser/light640.png'),
              require('@/assets/product/laser/light640.png'),
              require('@/assets/product/laser/light640.png'),
              require('@/assets/product/laser/light640.png'),
              require('@/assets/product/laser/light640.png'),
            ],
            models: [
              {
                key: '640',
                label: 'Light 640',
                image: require('@/assets/product/laser/640.png'),
              },
              {
                key: '960',
                label: 'Light 960',
                image: require('@/assets/product/laser/960.png'),
              },
              {
                key: '1390',
                label: 'Light 1390',
                image: require('@/assets/product/laser/1390.png'),
              },
              {
                key: '1610',
                label: 'Light 1610',
                image: require('@/assets/product/laser/1610.png'),
              },
            ],
            modelAdvantages: {
              640: [
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title: 'مساحة العمل',
                  bgColor: '#4285F4',
                  description: `Light640 (600*400mm)
Light960 (900*600mm)
<br>Light1390 (1300*900mm)
<br>Light1610 (1600*1000mm)`,
                  image: require('@/assets/product/laser/640-1.png'),
                },
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title: 'تركيز تلقائي + تحديد بالنقطة الحمراء',
                  bgColor: '#FFBC0C',
                  description:
                    'تتيح خاصية التركيز التلقائي تحديد موقع القطع والنقش بدقة وسرعة قبل التشغيل. ومع تحديد النقطة الحمراء، يمكن مشاهدة موضع العمل لحظة بلحظة، مما يوفر وقت المعالجة ويمنح نتائج أفضل.',
                  image: require('@/assets/product/laser/640-2.png'),
                },
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title: 'تصميم باب خلفي مفتوح',
                  bgColor: '#34A853',
                  description:
                    'يسمح التصميم المفتوح للباب الخلفي بوضع مواد بطول غير محدود للقطع والنقش. ألواح بطول 600 مم × ∞ تجعل العمل أكثر سهولة مع قيود أقل.',
                  image: require('@/assets/product/laser/640-3.png'),
                },
              ],
              960: [
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title: 'أداء متميز في القطع والنقش',
                  bgColor: '#4285F4',
                  description:
                    'مجهز بمنصة قطع ليزر واسعة، يحقق دقة وكفاءة بمستوى صناعي لمعالجة الخشب والأكريليك. يدعم الإنتاج الكمي للحرف الليزرية عالية الجودة ويعزز القدرة الإنتاجية بشكل كبير.',
                  image: require('@/assets/product/laser/960-1.png'),
                },
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title: 'أنبوب ليزر عالي الجودة ومكونات دقيقة',
                  bgColor: '#FFBC0C',
                  description:
                    'خط إنتاج متنوع يتيح اختيار أنواع ليزر وسرعات معالجة مختلفة حسب الحاجة الفعلية، ويوفر إمكانات غير محدودة لمعالجة الخشب والزجاج والأكريليك وغيرها.',
                  image: require('@/assets/product/laser/960-2.png'),
                },
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title: 'اختبارات صارمة لجودة الشعاع وضمان جودة عالية',
                  bgColor: '#34A853',
                  description:
                    'يتم اختيار أنابيب ليزر CO₂ عالية الجودة بعد اجتياز اختبارات صارمة وتحكم دقيق في المسار الضوئي وأكثر من 5 اختبارات قطع ونقش لضمان استقرار القدرة وجودة التفاصيل الدقيقة.',
                  image: require('@/assets/product/laser/960-3.png'),
                },
              ],
              1390: [
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title: 'خصائص أمان شاملة ومتقدمة',
                  bgColor: '#4285F4',
                  description: `1. زر الإيقاف الطارئ
<br>2. ضوء إنذار
<br>3. مفتاح مقاوم للماء
<br>4. سلك تأريض
<br>5. إنذار مدمج للكشف الحراري
<br>6. حماية الغطاء القلاب
<br>7. نافذة حماية من الزجاج المقسى`,
                  image: require('@/assets/product/laser/1390-1.png'),
                },
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title: 'متانة عالية وجودة فائقة',
                  bgColor: '#FFBC0C',
                  description: `1. مثالي للمشاريع الفردية أو الإنتاج واسع النطاق.
<br>2. نطاق واسع لمساحات العمل من 600×400 مم إلى 1600×1000 مم.
<br>3. سرعة نقش لا مثيل لها.
<br>4. تصميم من خبراء الصناعة.
<br>5. خيار مثالي للتخصيص والتعليم والتطبيقات الصناعية.`,
                  image: require('@/assets/product/laser/1390-2.png'),
                },
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title: 'تحسين الإنتاج عبر المراقبة الذكية',
                  bgColor: '#34A853',
                  description:
                    'مطوّر خصيصًا لحماية المكونات الحساسة (المحاور، رأس الليزر، العناصر البصرية، العدسات) من الغبار والأوساخ، ويضمن سنوات من التشغيل المستقر حتى مع الاستخدام المكثف.',
                  image: require('@/assets/product/laser/1390-3.png'),
                },
              ],
              1610: [
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title: 'تركيز تلقائي + تحديد بالنقطة الحمراء',
                  bgColor: '#4285F4',
                  description:
                    'تتيح خاصية التركيز التلقائي تحديد موضع القطع والنقش بسرعة ودقة. ومع تحديد النقطة الحمراء، يوفر Light 1610 وقت المعالجة ويمنح نتائج قطع ونقش ممتازة.',
                  image: require('@/assets/product/laser/1610-1.png'),
                },
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title: 'أداء متميز في القطع والنقش',
                  bgColor: '#FFBC0C',
                  description:
                    'مزود بمنصة قطع ليزر واسعة تحقق دقة وكفاءة بمستوى صناعي لمعالجة الخشب والأكريليك، ويدعم الإنتاج الكمي للحرف الليزرية عالية الجودة.',
                  image: require('@/assets/product/laser/1610-2.png'),
                },
                {
                  icon: require('@/assets/product/laser/tags1.png'),
                  title: 'متانة عالية وجودة فائقة',
                  bgColor: '#34A853',
                  description: `1. مثالي للمشاريع الفردية أو الإنتاج واسع النطاق.
<br>2. نطاق واسع لمساحات العمل من 600×400 مم إلى 1600×1000 مم.
<br>3. سرعة نقش لا مثيل لها.
<br>4. تصميم من خبراء الصناعة.
<br>5. خيار مثالي للتخصيص والتعليم والتطبيقات الصناعية.`,
                  image: require('@/assets/product/laser/1610-3.png'),
                },
              ],
            },
          },
          {
            key: 'lightblue530',
            label: 'Light Blue 530',
            images: [
              require('@/assets/product/laser/blue530.png'),
              require('@/assets/product/laser/blue530.png'),
              require('@/assets/product/laser/blue530.png'),
              require('@/assets/product/laser/blue530.png'),
              require('@/assets/product/laser/blue530.png'),
            ],
            advantages: [
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title: 'آلة نقش ليزر أزرق محمولة',
                bgColor: '#4285F4',
                description:
                  'تصميم أنيق وحديث ومضغوط مناسب لأي منزل أو مدرسة أو ورشة عمل. هيكل معدني مع غطاء أكريليك يسمح بوضع الجهاز بسهولة على أي طاولة مع أداء قطع قوي بقدرة 20W.',
                image: require('@/assets/product/laser/blue530-1.png'),
              },
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title: 'معالجة مغلقة بالكامل للحماية من الإصابات',
                bgColor: '#FFBC0C',
                description:
                  'تصميم مغلق بالكامل يوقف الجهاز تلقائيًا عند فتح الغطاء. وفي حالات الطوارئ يمكن إيقاف التشغيل فورًا بزر واحد، مما يجعله مناسبًا للاستخدام المنزلي والمدرسي.',
                image: require('@/assets/product/laser/blue530-2.png'),
              },
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title: 'معالجة متعددة المواد تدعم مئات الخامات',
                bgColor: '#34A853',
                description:
                  'إمكانية تخصيص أشكال وأنماط فريدة مع سلسلة منتجات ديناميكية. يمكن إضافة ملحقات لمعالجة مواد متنوعة مثل الأكواب والأجسام الأسطوانية، مما يجعله مثاليًا للمشروعات الصغيرة.',
                image: require('@/assets/product/laser/blue530-3.png'),
              },
            ],
          },
          {
            key: 'markm20',
            label: 'Mark M20',
            images: [
              require('@/assets/product/laser/m20.png'),
              require('@/assets/product/laser/m20.png'),
              require('@/assets/product/laser/m20.png'),
              require('@/assets/product/laser/m20.png'),
              require('@/assets/product/laser/m20.png'),
            ],
            advantages: [
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title: 'تطبيقات متعددة',
                bgColor: '#4285F4',
                description:
                  'مناسب لعدة مجالات مثل نقش المجوهرات، المنتجات المخصصة، تعريف القطع وغيرها، ويلبي احتياجات النقش من زجاجات العطور إلى اللوحات الصناعية الصغيرة.',
                image: require('@/assets/product/laser/m20.png'),
              },
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title: 'تطبيقات تعليمية مبتكرة',
                bgColor: '#FFBC0C',
                description:
                  'يدخل Mark M20 الدقة الصناعية إلى المجال التعليمي ليصبح مساعدًا شاملًا في تعليم STEM ويربي مهارات الطلاب من النقش الأساسي إلى تطوير المشاريع المعقدة.',
                image: require('@/assets/product/laser/m20-2.png'),
              },
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title: 'تصميم مدمج وحديث',
                bgColor: '#34A853',
                description:
                  'حجم صغير، ضوضاء منخفضة، نافذة رؤية واسعة، ومتطلبات عالية للمتانة. تصميمه العصري يفي بمعايير السلامة ومناسب للمؤسسات التعليمية وبيئات البيع بالتجزئة.',
                image: require('@/assets/product/laser/m20-3.png'),
              },
              {
                icon: require('@/assets/product/laser/tags1.png'),
                title: 'إتمام النقش خلال ثوانٍ',
                bgColor: '#0F9D58',
                description:
                  'حتى مع أصغر الخطوط يمكن لجهاز Mark إتمام النقش بدقة خلال ثوانٍ. وبالاقتران مع برنامج LightMaker، يتم تبسيط سير العمل وزيادة الإنتاجية بشكل كبير.',
                image: require('@/assets/product/laser/m20-4.png'),
              },
            ],
          },
          {
            key: 'accessories',
            label: 'الملحقات',
            images: [
              require('@/assets/product/laser/peijian.png'),
              require('@/assets/product/laser/peijian.png'),
              require('@/assets/product/laser/peijian.png'),
              require('@/assets/product/laser/peijian.png'),
              require('@/assets/product/laser/peijian.png'),
            ],
            advantages: [
              {
                description: `
                  · أماكن الاستخدام: مناسب لجميع المواقع التي تنتج دخانًا أو روائح أو غبارًا أو غازات سامة.
<br>· مجالات التطبيق: الإلكترونيات، الأجهزة الكهربائية، تصنيع الألعاب، المعادن الدقيقة، المجال الطبي وغيرها.
<br>· خصائص التصميم: تصميم مرن بمحطة عمل واحدة أو مزدوجة.
<br>· نظام الترشيح: مزود بطبقات ترشيح متعددة.
<br>· تنظيم تدفق الهواء: ضبط لا نهائي لقوة الشفط حسب حجم الانبعاثات.
<br>· كفاءة التنقية: تصل إلى 99.97%.
<br>· تصريف الهواء: يمكن تصريف الهواء النقي مباشرة داخل المكان.
`,
                image: require('@/assets/product/laser/accessories1.png'),
              },
              {
                description: `· نوع الجهاز: جهاز مساعد لآلات القطع / النقش بالليزر.
                     <br>· الوظيفة: تحقيق الحركة الدورانية لقطعة العمل.
<br>· الأجسام المناسبة: الأجسام الأسطوانية والأنبوبية.
<br>· التوسعة الوظيفية: توسيع المعالجة من الأسطح المسطحة إلى الأجسام الأسطوانية.`,
                image: require('@/assets/product/laser/accessories2.png'),
              },
              {
                description: `


· آلة تشكيل عالية الكفاءة توفر دقة تشكيل ممتازة.
<br>· تحكم عبر نظام CNC لسهولة التشغيل.
<br>· تتوفر عدة قوالب تشكيل.
<br>· نظام تثبيت سريع لرفع كفاءة العمل.
<br>· تجهيزات أمان متكاملة.
<br>· مناسبة لتشكيل مختلف المواد.
`,
                image: require('@/assets/product/laser/accessories3.png'),
              },
            ],
          },
        ],
      },
    },
  },
  support: {
    afterSales: {
      banner: {
        alt: 'لافتة تنزيلات الدروس',
        title: 'تحميل الدروس',
        image: require('@/assets/after/banner.png'),
      },
      downloadText: 'تحميل الدروس',
      items: [
        {
          id: 'mk-1',
          name: 'المزرعة الذكية',
          image: 'https://picsum.photos/seed/as-farm1/588/391',
          link: '#',
        },
        {
          id: 'mk-2',
          name: 'المنزل الذكي',
          image: 'https://picsum.photos/seed/as-home1/588/391',
          link: '#',
        },
        {
          id: 'mk-3',
          name: 'النقل الذكي',
          image: 'https://picsum.photos/seed/as-traffic1/588/391',
          link: '#',
        },
        {
          id: 'mk-4',
          name: 'المصنع الذكي',
          image: 'https://picsum.photos/seed/as-factory1/588/391',
          link: '#',
        },
        {
          id: 'mk-5',
          name: 'مساحة المبدعين',
          image: 'https://picsum.photos/seed/as-makerspace1/588/391',
          link: '#',
        },
        {
          id: 'mk-6',
          name: 'دورات الروبوت',
          image: 'https://picsum.photos/seed/as-robot1/588/391',
          link: '#',
        },
        {
          id: 'mk-7',
          name: 'دروس الذكاء الاصطناعي',
          image: 'https://picsum.photos/seed/as-ai1/588/391',
          link: '#',
        },
        {
          id: 'mk-8',
          name: 'دروس الإنترنت للأشياء',
          image: 'https://picsum.photos/seed/as-iot1/588/391',
          link: '#',
        },
      ],
    },
  },
};
